<template>
  <auth-shell title="تفعيل الحساب" subtitle="خطوة أخيرة ويصبح حساب المدرسة جاهزاً.">
    <div class="auth-alert ok"><i class="fa fa-whatsapp"></i><span>تم ارسال كود التفعيل على الرقم <bdi dir="ltr">{{ user.phone }}</bdi> على الواتساب.</span></div>
    <div class="auth-alert bad" v-if="error"><i class="fa fa-exclamation-circle"></i><span>{{ error }}</span></div>

    <label class="auth-field" for="act-code">
      <span class="auth-label">كود التفعيل</span>
      <span class="auth-input code">
        <input id="act-code" type="text" inputmode="numeric" autocomplete="one-time-code" v-model="code" v-on:keyup.enter="login()" placeholder="••••">
      </span>
    </label>

    <button class="auth-btn" @click="login()">
      تفعيل الحساب <i class="fa fa-check"></i>
    </button>

    <p class="auth-alt">
      الجوال غير صحيح؟
      <a href="javascript:;" @click="$router.push('/logout')">تسجيل الخروج</a>
    </p>
    <p class="auth-alt muted">اذا لم يصلك كود التفعيل برجاء التواصل مع الدعم الفني.</p>
  </auth-shell>
</template>

<script>
import AuthShell from '../components/AuthShell.vue';

export default {
    components: { AuthShell },
    created(){

    },
    data(){
        return {
            code: "",
            user: JSON.parse(localStorage.getItem("user")),
            jwt: JSON.parse(localStorage.getItem("user")).jwt,
            error: ""
        }
    },
    methods: {
        login(){
            var g = this;
            g.error = null;
            $.post(api + '/user/auth/activate', {
                jwt: this.jwt,
                code: this.code
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    r.response.activated = true;
                    localStorage.setItem("user", JSON.stringify(r.response))
                    window.location = '/'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        }
    }
}
</script>
